import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-footer3',
  templateUrl: './footer3.component.html',
  styleUrls: ['./footer3.component.scss']
})
export class Footer3Component implements OnInit {

  year: number;

  ngOnInit(): void {
    this.year = (new Date()).getFullYear();
  }

}
